"use client";

import { c as _c } from "react/compiler-runtime";
import type { ToastRecord } from "@/types/toast";
import type { FocusEvent } from "react";
import { useState } from "react";
import { useDocumentHidden } from "@/hooks/use-document-hidden";
import { ToastItem } from "@/ui/toast/item";
import { AnimatePresence } from "motion/react";
interface ToastViewportProps {
  toasts: ToastRecord[];
  maxVisible: number;
  onDismiss: (id: string) => void;
}
export function ToastViewport(t0) {
  const $ = _c(42);
  const {
    toasts,
    maxVisible,
    onDismiss
  } = t0;
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);
  const hidden = useDocumentHidden();
  const paused = hovered || focused || hidden;
  let T0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== maxVisible || $[1] !== onDismiss || $[2] !== paused || $[3] !== toasts) {
    const visible = toasts.slice(0, maxVisible);
    let t13;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = function handleBlur(event) {
        if (!event.currentTarget.contains(event.relatedTarget)) {
          setFocused(false);
        }
      };
      $[17] = t13;
    } else {
      t13 = $[17];
    }
    const handleBlur = t13;
    t10 = "Notifications";
    t11 = -1;
    t12 = "pointer-events-none fixed inset-x-0 bottom-20 z-50 flex justify-center p-4 outline-none sm:right-20 sm:left-auto sm:w-96 sm:p-6";
    t5 = "flex w-full flex-col gap-2";
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = () => setHovered(true);
      t7 = () => setHovered(false);
      t8 = () => setFocused(true);
      $[18] = t6;
      $[19] = t7;
      $[20] = t8;
    } else {
      t6 = $[18];
      t7 = $[19];
      t8 = $[20];
    }
    t9 = handleBlur;
    T0 = AnimatePresence;
    t1 = false;
    t2 = "popLayout";
    t3 = "bottom";
    let t14;
    if ($[21] !== onDismiss || $[22] !== paused) {
      t14 = toast => <ToastItem key={toast.id} toast={toast} paused={paused} onDismiss={onDismiss} />;
      $[21] = onDismiss;
      $[22] = paused;
      $[23] = t14;
    } else {
      t14 = $[23];
    }
    t4 = visible.map(t14);
    $[0] = maxVisible;
    $[1] = onDismiss;
    $[2] = paused;
    $[3] = toasts;
    $[4] = T0;
    $[5] = t1;
    $[6] = t10;
    $[7] = t11;
    $[8] = t12;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    T0 = $[4];
    t1 = $[5];
    t10 = $[6];
    t11 = $[7];
    t12 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
    t8 = $[15];
    t9 = $[16];
  }
  let t13;
  if ($[24] !== T0 || $[25] !== t1 || $[26] !== t2 || $[27] !== t3 || $[28] !== t4) {
    t13 = <T0 initial={t1} mode={t2} anchorY={t3}>{t4}</T0>;
    $[24] = T0;
    $[25] = t1;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t5 || $[32] !== t6 || $[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
    t14 = <ol className={t5} onPointerEnter={t6} onPointerLeave={t7} onFocus={t8} onBlur={t9}>{t13}</ol>;
    $[30] = t13;
    $[31] = t5;
    $[32] = t6;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t12 || $[40] !== t14) {
    t15 = <section aria-label={t10} tabIndex={t11} className={t12}>{t14}</section>;
    $[37] = t10;
    $[38] = t11;
    $[39] = t12;
    $[40] = t14;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  return t15;
}